module.exports = __webpack_public_path__ + "static/img/fefco204_1.9ae3e15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/fefco204_1.png
// module id = ZDiR
// module chunks = 0